import React from 'react';
import { Link } from 'react-router-dom';

import Header from '../../common/Header';
import styles from '../../assets/css/booking.module.css';
import { formatDate } from '../../lib/timeFormat';

const BookingSuccess = ({ booking }) => {
  const goToTicket = (e) => {
    e.preventDefault();
    window.open(booking.ticketLink, '_blank');
  };
  const goToManageMyBooking = (e) => {
    e.preventDefault();
    window.open(booking.manageMyBookingLink, '_blank');
  };
  const message =`${booking.pnr}\r\n${booking.origin.iataCode} → ${booking.destination.iataCode}\r\n${formatDate(booking.date)}`;
  const encodedMessage = encodeURIComponent(message);

  return (
    <>
      <header className={styles.booking_header}>
        <Header />
        <div className={styles.steps_indicator_final}>
          <span className="iconify" data-icon="ic:round-check-circle"></span>
          <p>تم تأكيد الحجز المبدئي، وسيظل ساريًا لمدة ساعتين.</p>
        </div>
      </header>

      <main className={styles.booking_Wrapper}>
        <div className={styles.booking_status_message} style={{textAlign:'center', padding:'64px 0 128px 0'}}>
          {
            !booking.ticketLinkUrl &&
            <>
              <a href={`https://wa.me/249999990558?text=${encodedMessage}`} target="_blank" className='button' style={{ fontSize: '1.5em', alignItems: 'center', marginBottom: 20, padding:'16px 16px', borderRadius:34 }} rel="noreferrer">
                <i style={{ color: '#25d366', marginLeft: 12 }} className="fab fa-whatsapp"></i>
                 أكمل اجراءات السداد
              </a>
              <p>تم إرسال رسالة لبريدك الإلكتروني لتأكيد الحجز <span className={styles.booking_reference}>{booking.pnr}</span></p>
            </>
          }
          {
            booking.ticketLinkUrl &&
            <>
              <h1>تم تأكيد حجز الرحلة</h1>
            </>
          }

          {booking.ticketLinkUrl && <div>
            <p>يمكنك طباعة التذكرة او تحميل نسخة PDF عن طريق الزر التالي</p>
            <button className="button large-button" onClick={goToTicket}>طباعة <span className="iconify" data-icon="ic:outline-print"></span></button>
            <p className='booking_success_note'> سيتم إرسال نسخة من التذكرة إلى بريدك الإلكتروني تلقائيا * </p>
          </div>}

          {!booking.ticketLink && booking.manageMyBookingLink && <div style={{ margin: '40px 0' }}>
            <p>يمكنك متابعة حجزك عبر الرابط</p>
            <button className="button large-button" onClick={goToManageMyBooking}>أدر حجزي <span className="iconify" data-icon="ic:outline-print"></span></button>
          </div>}
        </div>
      </main>
    </>
  );
};

export default BookingSuccess;